import React from 'react';

import { InformationCircleSansSerif } from '@videoblocks/react-icons';

import { Tooltip } from '../../storywind';

const LegalDisclaimerTooltip = () => {
  const tooltipMessage = (
    <div>
      <p className="text-xs font-normal text-center m-0 my-1">
        This image is a snapshot from a video. Additional rights and clearance
        measures may be required.
      </p>
    </div>
  );
  return (
    <Tooltip
      content={tooltipMessage}
      placement="auto"
      containerClassName="bg-gray-940 opacity-90 rounded max-w-sm px-10 py-2"
    >
      <InformationCircleSansSerif className="h-4 w-4 fill-white inline ml-1 relative top-0.5" />
    </Tooltip>
  );
};

export default LegalDisclaimerTooltip;
